<div class="dots-horizontal-holder">
    <div class="dots-horizontal">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
    </div>
</div>
